module.exports = __webpack_public_path__ + "static/media/Grande-Vista-Estates-Master-Deed-By-Laws.8971f6c5.pdf";